<template>
    <div :class="lightMood ? 'q-containerCopy' : 'q-container'">
        <div class="d-flex justify-content-between add-weight-section">
            <QuestionWeight :template="template" type="arrange"/>
            <!-- <span @click="clearHandler" class="reset-data-btn">Reset All</span> -->
        </div>
        <div v-for="(q, idx) in template.questions.arrange.questions"
             :key="idx"
             class="t-f-q-body q-body d-flex  flex-column justify-content-start">
            <div class="d-flex gap-3">
                <div class="d-flex flex-column w-100 position-relative single-q-container">

                    <QuestionComponent :id="'arrange'+idx" :template="template" type="arrange" :index="idx"
                                       :validationCB="arrangeQuestionsValidation"/>

                    <div class="err w-75" v-if="q.errors['question'].length > 0">
                        <div v-for="msg in q.errors['question']" class="text-danger">{{msg}}</div>
                    </div>
                </div>

                <div class="align-self-end add-question-icon"
                     v-if="(template.questions.arrange.questions.length - 1) === idx">
                        <span class="add-question"
                              title="Add Question"
                              @click="addQuestionHandler($event, 'arrange')">+
                        </span>
                </div>
            </div>
<!--                        <div class="d-flex justify-content-between gap-3 my-3">-->
<!--                            <div class="answers-style">-->
<!--                                <div class="d-flex flex-column gap-3 answers-container">-->
<!--                                    <div v-for="(a,index) in q.answers" class="d-flex gap-4 align-items-center"-->
<!--                                         draggable="true"-->
<!--                                         @dragenter="dragEnterHandler($event, a, idx, index)"-->
<!--                                         @dragstart="dragStartHandler($event, a, idx, index)"-->
<!--                                         @touchmove="touchHandler($event, a, idx, index, true)"-->
<!--                                         @touchend="touchHandler($event, a, idx, index, false)"-->
<!--                                         @drop="dropHandler($event, a, idx, index)"-->
<!--                                         @dragenter.prevent-->
<!--                                         @dragover.prevent-->
<!--                                         @dragend="dragExitHandler($event, a, idx, index)"-->
<!--                                    >-->
<!--                                                     <span class="sort-icon"-->

<!--                                                     >-->
<!--                                                         <font-awesome-icon :icon="['fas', 'bars']" size="sm"/>-->
<!--                                                     </span>-->
<!--                                                    <div class="m-c-answer-container position-relative" :style="{backgroundColor: a.bgColor}">-->
<!--                                                        <textarea-->
<!--                                                               class="w-100 q-input"-->
<!--                                                               autocomplete="off"-->
<!--                                                               @input="answerTextChangeHandler($event, idx, index ,'arrange')"-->
<!--                                                               :placeholder="a.key" v-model="a.value">-->
<!--                                                        </textarea>-->
<!--                                                        <span class="delete-answer-icon"-->
<!--                                                              v-if="q.answers.length > 2"-->
<!--                                                              @click="deleteAnswerHandler($event, idx, index, 'arrange')">-->
<!--                                                                <font-awesome-icon :icon="['fas', 'times']" size="sm"/>-->
<!--                                                            </span>-->
<!--                                                    </div>-->


<!--                                                    <div class="err" v-if="q.errors['answers']?.length > 0">-->
<!--                                                        <div class="text-danger">{{q.errors['answers'][index]}}</div>-->
<!--                                                    </div>-->
<!--                                    </div>-->

<!--                                </div>-->
<!--                                <div class="err" v-if="q.errors['general'].length > 0">-->
<!--                                    <div v-for="msg in q.errors['general']" class="text-danger">{{msg}}</div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                            <div class="align-self-start"-->
<!--                                 v-if="( q.answers.length < 10 )">-->
<!--                                    <span class="add-question"-->
<!--                                          title="Add Answer"-->
<!--                                          @click="addAnswerHandler($event, idx ,'arrange')">+</span>-->
<!--                            </div>-->

<!--                        </div>-->
            <div class="d-flex justify-content-between gap-3 my-3">
                <p class="my-0">Answers</p>
                <div class="align-self-start" v-if="( q.answers.length < 10 )">
                    <span class="add-question"
                          title="Add Answer"
                          @click="addAnswerHandler($event, idx ,'arrange')">+
                    </span>
                </div>
            </div>
            <draggable class="list-group w-100" :list="q.answers" group="people" @change="log">
                <template #item="{ element, index }">
                    <div class="d-flex justify-content-between gap-3 my-3 dragableStyle">
                        <div class="answers-style">
                            <div class="d-flex gap-3 answers-container" :class="{ 'not-draggable': !enabled }">
                                <span class="sort-icon">
                                    <font-awesome-icon :icon="['fas', 'bars']" size="sm"/>
                                </span>

                                <div class="m-c-answer-container position-relative" :style="{backgroundColor: element.bgColor}">
                                    <textarea class="w-100 q-input" autocomplete="off" @input="answerTextChangeHandler($event, idx, index ,'arrange')"
                                            :placeholder="element.key" v-model="element.value">
                                    </textarea>
                                    <span class="delete-answer-icon"
                                          v-if="q.answers.length > 2"
                                          @click="deleteAnswerHandler($event, idx, index, 'arrange')">
                                        <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                                    </span>
                                </div>

                                <div class="err" v-if="q.errors['answers']?.length > 0">
                                    <div class="text-danger">{{q.errors['answers'][index]}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </draggable>
        </div>
    </div>

    <ConfirmationModal v-if="confirmFlag" :message="confirmMsg" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
    <span v-if="lightMood"></span>
</template>


<script>
    import {toRef, ref, defineAsyncComponent, computed} from "vue";
    import increaseTemplateQuestions from "../../../helpers/increaseTemplateQuestionsCounter";
    import decreaseTemplateQuestions from "../../../helpers/decreaseTemplateQuestionsCounter";
    import QuestionWeight from "../../components/QuestionWeight";
    import QuestionComponent from "../../components/templateComponents/questionComponent";
    import draggable from "vuedraggable";

    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../components/ConfirmationModal')
    );
    import qustionValidation from "../../../validation/qustionValidation";
    import {useStore} from "vuex";
    import {logger} from "../../../helpers/logger";

    export default {
        name: 'app',
        components: {draggable, QuestionWeight, QuestionComponent, ConfirmationModal},
        props: {
            template: Object
        },
        setup(props, context) {
            const store = useStore();
            const confirmFlag = ref(false);
            const confirmMsg = ref('');
            const originalData = ref([]);
            const sourceData = ref({
                order: 0,
                value: ''
            });
            const destData = ref({
                idx: 0,
                order: 0,
                value: ''
            });
            const template = toRef(props, 'template');
            const lightMood = computed({
                get() {
                    return store.state.settings.isLightMood;
                },
            });

            const addQuestionHandler = (e, type) => {


                let length = template.value.questions[type]?.questions?.length;
                console.log({length})
                let lastElement = template.value.questions[type].questions[length - 1];
                let isErrors = false;
                let question = null;

                isErrors = arrangeQuestionsValidation(lastElement);
                console.log({isErrors})
                question = {
                    question: '',
                    answers: [
                        {
                            order: 1,
                            value: '',
                            bgColor: 'transparent',
                            is_correct: false
                        },
                        {
                            order: 2,
                            value: '',
                            bgColor: 'transparent',
                            is_correct: false
                        },
                    ],
                    isDelete: true,
                    errors: {
                        question: [],
                        answers: [],
                        general: []
                    }
                };


                if (!isErrors) {
                    addNewQuestionData(question, type)
                }

            };

            const addAnswerHandler = (e, idx, type) => {
                let answersLength = template.value.questions[type].questions[idx].answers.length;
                let errors = null;
                let element = template.value.questions[type].questions[idx];
                if (answersLength < 10) {
                    template.value.questions[type].questions[idx].answers.push(
                        {
                            order: answersLength + 1,
                            value: '',
                            is_correct: false
                        }
                    )
                }

                errors = arrangeQuestionsValidation(element);
                if (!errors)
                    increaseTemplateQuestions(template, 'arrange');
                else
                    decreaseTemplateQuestions(template, 'arrange');

            };

            const deleteAnswerHandler = (e, idx, index, type) => {

                console.log({idx}, {index})
                let errors = null;
                template.value.questions[type].questions[idx].answers.splice(index, 1);

                template.value.questions[type].questions[idx].answers.forEach((ans, idx) => {
                    ans.order = idx + 1;
                });
                let element = template.value.questions[type].questions[idx];
                errors = arrangeQuestionsValidation(element);
                if (!errors)
                    increaseTemplateQuestions(template, 'arrange');
                else
                    decreaseTemplateQuestions(template, 'arrange');
                if (template.value.questions[type].questions[idx].answers.length === 0) {
                    template.value.questions[type].questions[idx].errors['general'] = ['*Required'];
                }
            };

            const deleteQuestionHandler = (idx, type) => {
                let errors = null;
                logger(['idx -> ', idx]);
                let element = template.value.questions.arrange.questions[idx];
                errors = arrangeQuestionsValidation(element);
                if (!errors)
                    decreaseTemplateQuestions(template, 'arrange');
                template.value.questions[type].questions.splice(idx, 1);
            };

            const answerTextChangeHandler = (e, idx, index, type) => {


                let element = template.value.questions[type].questions[idx];
                let errors = null;
                errors = arrangeQuestionsValidation(element);
                if (!errors)
                    increaseTemplateQuestions(template, 'arrange');
                else
                    decreaseTemplateQuestions(template, 'arrange');
            };

            const arrangeQuestionsValidation = (element) => {

                console.log({element})
                let BreakException = {};
                let isErrors = {
                    question: false,
                    answers: false,
                    answersCount: 0
                };

                if (template.value.questions['arrange'].weight === null) {
                    template.value.questions['arrange']['errors']['weight']['isError'] = true
                    template.value.questions['arrange']['errors']['weight']['message'] = '*Required'
                }

                element.errors['answers'] = [];
                element.errors['question'] = [];
                element.errors['general'] = [];

                isErrors.question = qustionValidation(element);

                if (element.answers.length === 0) {
                    element.errors['general'] = ['*Required'];
                    isErrors.answers = true;
                } else if (element.answers.length > 10) {
                    element.errors['general'] = ["* too many, answers must be less than 10"];
                    isErrors.answers = true;
                } else {
                    element.errors['general'] = [];
                    isErrors.answers = false;
                }

                element.answers.forEach((ans, idx) => {
                    if (ans.value !== '') {
                        element.errors['answers'][idx] = '';
                        isErrors.answers = false;
                    } else {
                        element.errors['answers'][idx] = '*Required';
                        isErrors.answers = true;

                    }
                });

                // if (element.errors['general'].length === 0) {
                //     try {
                //         element.answers.forEach((ans) => {
                //             if (ans.is_correct === true) {
                //                 element.errors['general'] = [];
                //                 isErrors.answers = false;
                //                 throw BreakException;
                //             } else {
                //                 element.errors['general'] = ['* please select correct answer'];
                //                 isErrors.answers = true;
                //             }
                //         });
                //     } catch (e) {
                //         if (e !== BreakException) throw e;
                //     }
                // }

                isErrors.answersCount = 0;
                element.errors['answers'].forEach(ans => {
                    ans !== '' ? isErrors.answersCount += 1 : null
                });
                isErrors = (isErrors.answersCount > 0) || (element.errors['question'].length > 0) || (element.errors['general'].length > 0);
                template.value.questions['arrange'].isError = isErrors;
                console.log({isErrors})
                return isErrors;
            };

            const confirmModalHandler = (e) => {
                confirmFlag.value = false;
                if (e) {
                    template.value.questions['arrange'].questions = [{
                        question: '',

                        answers: [
                            {
                                order: 1,
                                value: '',
                                bgColor: 'transparent',
                                is_correct: false
                            },
                            {
                                order: 2,
                                value: '',
                                bgColor: 'transparent',
                                is_correct: false
                            }
                        ],
                        isDelete: true,
                        errors: {
                            question: [],
                            answers: [],
                            general: []
                        }
                    }];
                    if (template.value.questions['arrange'].counter > 0) {
                        template.value.questions['arrange'].counter = 0;
                        template.value.questionsCount -= 1;
                    }
                    template.value.questions['arrange'].isError = false;
                }
            };

            const clearHandler = () => {
                template.value.questions['arrange'].weight = null;
                template.value.questions['arrange']['errors']['weight']['isError'] = false;
                template.value.questions['arrange']['errors']['weight']['message'] = '';

                if (template.value.questions['arrange'].counter > 0 || template.value.questions['arrange'].isError) {
                    confirmFlag.value = true;
                    confirmMsg.value = 'Are you sure you want to reset data?';
                }

            };

            const addNewQuestionData = (question, type) => {
                template.value.questions[type].questions.push(
                    question
                )
            };

            const checkErrors = (idx) => {
                let retVale = true;
                let errors = template.value.questions.arrange.questions[idx].errors;
                if (errors.question.length === 0 && errors.answer.length === 0) {
                    retVale = false;
                }
                return retVale;
            };

            const touchHandler = async (e, data, qIdx, aIdx, isMoving = false) => {


                const clientX = e.clientX || e.changedTouches[0].clientX;
                const clientY = e.clientY || e.changedTouches[0].clientY;
                let elmEnd = document.elementFromPoint(
                    clientX,
                    clientY
                );

                console.log({elmEnd})

                if (isMoving) {

                } else {
                    let elmEnd = document.elementFromPoint(
                        clientX,
                        clientY
                    );
                }

                // console.log({data}, {qIdx}, {aIdx});
                // originalData.value = template.value.questions['arrange'].questions[qIdx]['answers'].map((obj) => ({ ...obj }));
                // sourceData.value = {
                //     idx: aIdx,
                //     order: data.order,
                //     value: data.value
                // }
            };

            const dragStartHandler = async (e, data, qIdx, aIdx) => {

                console.log({data}, {qIdx}, {aIdx});
                originalData.value = template.value.questions['arrange'].questions[qIdx]['answers'].map((obj) => ({...obj}));
                sourceData.value = {
                    idx: aIdx,
                    order: data.order,
                    value: data.value
                }
            };

            const dropHandler = (e, data, qIdx, aIdx) => {
                console.log("dropHandler => ", {data}, {qIdx}, {aIdx});
                template.value.questions['arrange'].questions[qIdx]['answers'][aIdx]['bgColor'] = "transparent";
                originalData.value = template.value.questions['arrange'].questions[qIdx]['answers'].map((obj) => ({...obj}));
            };

            const dragEnterHandler = (e, data, qIdx, aIdx) => {
                e.preventDefault();
                const index = sourceData.value.idx;
                let sourceValue = null;
                let destValue = null;

                destData.value.idx = aIdx;
                template.value.questions['arrange'].questions[qIdx]['answers'] = originalData.value.map((obj) => ({...obj}));

                if (index !== +aIdx) {
                    sourceValue = template.value.questions['arrange']?.questions[qIdx]['answers'][index]['value'];
                    destValue = template.value.questions['arrange']?.questions[qIdx]['answers'][aIdx]['value'];

                    template.value.questions['arrange'].questions[qIdx]['answers'][aIdx]['value'] = sourceValue;
                    template.value.questions['arrange'].questions[qIdx]['answers'][index]['value'] = destValue;
                    template.value.questions['arrange'].questions[qIdx]['answers'][aIdx]['bgColor'] = "#034560";
                }
                console.log("dragEnterHandler => ", {data}, {qIdx}, {aIdx});
            };

            const dragExitHandler = (e, data, qIdx, aIdx) => {
                console.log("dragExitHandler ", {data}, {qIdx}, {aIdx});
                template.value.questions['arrange'].questions[qIdx]['answers'][destData.value.idx]['bgColor'] = "transparent";
                template.value.questions['arrange'].questions[qIdx]['answers'].forEach((ans, idx) => {
                    ans.order = idx + 1;
                })
            };

            return {
                template,
                confirmFlag,
                confirmMsg,
                originalData,
                lightMood: computed(() => store.state.settings.isLightMood),
                dragStartHandler,
                dropHandler,
                dragEnterHandler,
                dragExitHandler,
                confirmModalHandler,
                addQuestionHandler,
                deleteQuestionHandler,
                deleteAnswerHandler,
                arrangeQuestionsValidation,
                answerTextChangeHandler,
                addNewQuestionData,
                addAnswerHandler,
                checkErrors,
                touchHandler,
                clearHandler,
                sourceData,
                destData,
                increaseTemplateQuestions,
                decreaseTemplateQuestions

            }
        }
    }

</script>

<style scoped>
    .add-question-icon{
        margin-bottom:46px;
    }
    .add-weight-section{
        margin-bottom: 20px;
    }
    .sort-icon {
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .answers-style {
        padding: 11px;
        overflow: auto;
        max-height: 270px;
        width: 98%;
    }

    input[type=text] {
        height: 30px;
    }

    .input-section {
        height: 120px;
    }

    .weight-style {
        background-color: transparent;
        border: 1px solid #39525C;
        border-radius: 4px;
        width: 86px;
        height: 32px;
        color: #FFF;
        padding: 10px;
    }

    .q-weight-container {
        width: 18%;
    }

    .q-container {
        overflow-y: auto;
        padding: 20px;
        /* margin-top: 12px; */
        background-color: #032A3A;
        border-radius:0 0 5px 5px;
        height: 100%;
    }

    .q-containerCopy {
        overflow-y: auto;
        padding: 20px;
        /* margin-top: 12px; */
        /*background-color: #032A3A;*/
        border-radius:0 0 5px 5px;
        height: 100%;
    }

    .q-input {
        background-color: transparent !important;
        border: none;
        /* border-radius: 4px; */
        color: var(--main-color);
        padding: 10px;
        overflow-y: auto;
        /* overflow-x: hidden; */
        height: 44px;
        max-height: 60px;
    }

    .q-input:focus,
    .q-input:focus-visible {
        outline: 0;
    }

    .add-question {
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;
        color: #e65c00;
        border: 1px solid;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    .add-question:hover {
        background-color: #e65c00;
        color: #032a3a;
    }

    .m-c-answer-container {
        width: 100%;
        border: 1px solid #39525C;
        border-radius: 8px;
        padding: 8px;
        display: flex;
        color: var(--main-color);
        gap: 4px;
    }

    .m-c-answer-container > input[type=text],
    .m-c-answer-container > input[type=text]:focus,
    .m-c-answer-container > input[type=text]:focus-visible {
        border: 0;
        color: var(--main-color);
        background-color: transparent;
        outline: 0;
    }

    .delete-answer-icon {
        position: absolute;
        top: -5px;
        right: -4px;
        display: flex;
        background-color: #E95626;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        border: 1px solid #E95626;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        color: #032a3a;
        cursor: pointer;
    }

    .single-q-container {
        height: 120px;
    }

    .dragableStyle{
        width: 100%;
    }

</style>